import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    privacy: {},
    errors: {}
};

getters['fetchPrivacy'] = function(state) { return state.privacy }

const actions = {    
    getPrivacy(context) {
        return ApiService
            .get('profile/edit/settings/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_PRIVACY', response.data)
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    setPrivacy(context, payload) {
        return ApiService
            .put('profile/edit/settings/', payload)
            .then((response) => {
                context.commit('SET_PRIVACY', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    }
};

const mutations = {
    SET_PRIVACY(state, privacy) {
        state.privacy = privacy;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
